import {
  isCentreSubscription,
  subscriptionTypes,
  subscriptionTypesObj
} from '@constants/index';

export const getSubscriptionTypeLabelFromType = (
  type?: number,
  contentTypeId?: number
): string => {
  if (
    type === subscriptionTypes.CENTRE ||
    isCentreSubscription(type, contentTypeId)
  ) {
    return 'Offline';
  }

  if (type != null && subscriptionTypesObj[type]) {
    return subscriptionTypesObj[type];
  }

  return 'NA';
};

export const getSubscriptionTypeLabelFromPriceMode = (
  priceMode?: string
): string => {
  if (!priceMode) return 'NA';

  const normalized = priceMode.toLowerCase().replace(/-/g, '_');

  const priceModeLabels: Record<string, string> = {
    plus: 'Plus',
    lite: 'Lite',
    iconic: 'Iconic',
    iconic_pro: 'Iconic Pro',
    offline: 'Offline',
    combo: 'Combo',
    prime: 'Prime'
  };

  return priceModeLabels[normalized] ?? priceMode;
};

export const resolveSubscriptionTypeForAnalytics = (
  subscriptionType?: string | number
): string => {
  if (typeof subscriptionType === 'number') {
    return getSubscriptionTypeLabelFromType(subscriptionType);
  }

  if (typeof subscriptionType === 'string') {
    const fromPriceMode =
      getSubscriptionTypeLabelFromPriceMode(subscriptionType);
    if (fromPriceMode !== subscriptionType) {
      return fromPriceMode;
    }

    const typeFromKey =
      subscriptionTypes[
        subscriptionType.toUpperCase() as keyof typeof subscriptionTypes
      ];
    if (typeFromKey != null) {
      return getSubscriptionTypeLabelFromType(typeFromKey);
    }

    return subscriptionType;
  }

  return 'NA';
};
